import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';


@Component({
    selector: 'app-gradescale-dialogue',
    templateUrl: './gradescale-dialogue.component.html',
    styleUrls: ['./gradescale-dialogue.component.scss'],
    standalone: false
})
export class GradescaleDialogueComponent implements OnInit {

  gradeScaleLink: string;
  constructor(@Inject(MAT_DIALOG_DATA) data: { gsLink: string }) {
    this.gradeScaleLink = data.gsLink;
  }



  ngOnInit(): void {
    let cdkHiddenElements = document.getElementsByClassName("cdk-visually-hidden");
    for(let i=0; i<cdkHiddenElements.length; i++) {
      cdkHiddenElements.item(i)?.removeAttribute("tabindex");
    }
  }

  onClickContinue() {
    window.open(this.gradeScaleLink, '_blank');
  }

}
